<script setup>
import { SecondaryButton } from "@Components/Button";
import { FormLabel, FormListbox, FormTextarea } from "@Components/Form";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";

const props = defineProps({
    title: String,
    description: String,
    keywordsLabel: String,
    keywordsPlaceholder: String,
    keywordsHelp: String,
    styleLabel: String,
    stylePlaceholder: String,
    styleHelp: String,
    customInstructionsLabel: String,
    customInstructionsPlaceholder: String,
    customInstructionsHelp: String,
    processing: Boolean,
});

const { t: __ } = useI18n();

const model = defineModel();

const styleItems = [
    {
        key: "informative",
        name: __("Informatif"),
    },
    {
        key: "commercial",
        name: __("Commercial"),
    },
    {
        key: "local",
        name: __("Local"),
    },
    {
        key: "brands",
        name: __("Marques"),
    },
    {
        key: "comparative",
        name: __("Comparatif"),
    },
    {
        key: "guide",
        name: __("Guide"),
    },
];
</script>
<template>
    <div class="flex flex-col space-y-6">
        <FormTextarea v-model="model.keywords" :label="keywordsLabel" :help="keywordsHelp" :placeholder="keywordsPlaceholder" :rows="10" />

        <FormListbox
            v-model="model.style"
            :label="styleLabel"
            :help="styleHelp"
            :placeholder="stylePlaceholder"
            :items="styleItems"
            itemKey="key"
            itemDisplay="name"
            required />

        <Disclosure as="div" class="mt-2" v-slot="{ open }">
            <div class="flex flex-col space-y-2">
                <div class="flex justify-between items-center gap-3">
                    <FormLabel for="custom-instructions">{{ customInstructionsLabel }}</FormLabel>
                    <DisclosureButton :as="SecondaryButton" :icon="open ? ChevronUpIcon : ChevronDownIcon" type="button" />
                </div>
                <DisclosurePanel>
                    <FormTextarea
                        id="custom-instructions"
                        v-model="model.custom_instructions"
                        rows="5"
                        :help="customInstructionsHelp"
                        :placeholder="customInstructionsPlaceholder" />
                </DisclosurePanel>
            </div>
        </Disclosure>
    </div>
</template>
